module.exports = "/packs/002-7065e82a9eb2e00eb4af5c928dabfcb4.jpg";